import { ApiKey, DepreactedApiKey } from "./api-key.type";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class ApiKeysService {

    constructor(private http: HttpClient) {}
    

    getAPIKeys(): Observable<ApiKey[]> {
        return this.http.get<Array<ApiKey>>(`/api/key`);
    }

    newAPIKey(): Observable<ApiKey[]> {
        return this.http.post<ApiKey[]>(`/api/key`, {});
    }

    deleteAPIKey(key: ApiKey): Observable<ApiKey[]> {
        return this.http.delete<ApiKey[]>(`/api/key/${key.value}`);
    }

    renewAPIKey(key: ApiKey): Observable<ApiKey[]> {
        return this.http.put<ApiKey[]>(`/api/key/renew/${key.value}`, {});
    }

    getDeprecatedAPIKeys(): Observable<DepreactedApiKey[]> {
        return this.http.get<DepreactedApiKey[]>(`/api/key/deprecated`);
    }
}